import React from "react"
import ModeProvider from "./src/context/ModeProvider"
import CurrentUserProvider from "./src/context/CurrentUserProvider";
import CartProvider from "./src/context/CartProvider"
import ProductsProvider from "./src/context/ProductsProvider"
import ProgrammticForm from "./src/context/ProgrammaticFormProvider"
import DiscountProvider from "./src/context/DiscountProvider";

export const wrapRootElement = ({ element }) => (
  <ModeProvider>
    <CurrentUserProvider>
      <ProductsProvider>
        <CartProvider>
          <DiscountProvider>
            <ProgrammticForm>
              {element}
            </ProgrammticForm>
          </DiscountProvider>
        </CartProvider>
      </ProductsProvider>
    </CurrentUserProvider>
  </ModeProvider>
) 

// The chat widget — the circle in the corner, served WHOLE by the Session
// Manager so every app on this machine runs the same current copy and this
// project installs nothing. Development only; see gatsby-node.js.
export const onClientEntry = () => {
  // An https page (ntm.dev.newtomelbourne.org) must load it over https, or the browser blocks it.
  const where = window.location.protocol === 'https:'
    ? process.env.VOICE_WIDGET_HTTPS
    : process.env.VOICE_WIDGET
  if (!where) return
  const tag = document.createElement("script")
  tag.src = `${where}/widget.js`
  tag.defer = true
  document.body.appendChild(tag)
}
